import plays from './msgs/plays';
import pbHealth from './msgs/pbHealth';
import audioLane from './msgs/audioLane';
import tfa from './msgs/tfa';
import admin from './msgs/admin';
import misc from './msgs/misc';
import ix from './msgs/ix';
import kiosk from './msgs/kiosk';
import rx from './msgs/rx';
import psettings from './msgs/psettings';
import layout from './msgs/layout';
import log from './msgs/log';
import act from './msgs/act';
import capps from './msgs/capps';
import attrs from './msgs/attrs';
import regions from './msgs/regions';
import tagm from './msgs/tagm';
import billing from './msgs/billing';
import plan from './msgs/plan';
import feeds from './msgs/feeds';
import groups from './msgs/groups';
import analytics from './msgs/analytics';
import alerts from './msgs/alerts';
import health from './msgs/health';
import reports from './msgs/reports';
import org from './msgs/org';
import playlist from './msgs/playlist';
import campaign from './msgs/campaign';
import toast from './msgs/toast';
import notify from './msgs/notify';
import sync from './msgs/sync';
import fonts from './msgs/fonts';
import comp from './msgs/comp';
import buildings from './msgs/buildings';
import played from './msgs/played';
import pcp from './msgs/pcp';
import live from './msgs/live';
import screen from './msgs/screen';
import placements from './msgs/placements';
import publish from './msgs/publish';
import pair from './msgs/pair';
import players from './msgs/players';
import appsCat from './msgs/appsCat';
import content from './msgs/content';
import ui from './msgs/ui';
/**
 * English messages (the source). Keys are grouped by screen; `common` holds shared words.
 * Arabic lives in ar.ts with the same shape. Plurals: "one | other" here; Arabic uses six forms.
 */
const en = {
  common: {
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    close: 'Close',
    remove: 'Remove',
    delete: 'Delete',
    edit: 'Edit',
    loading: 'Loading…',
    somethingWrong: 'Something went wrong',
    serverUnavailable: "Can't reach the server right now. You're still signed in; try again in a moment.",
    signIn: 'Sign in',
    signOut: 'Sign out',
    yourName: 'Your name',
    workEmail: 'Work email',
    password: 'Password',
    items: '{n} item | {n} items',
    players: '{n} player | {n} players',
  },
  theme: {
    label: 'Theme',
    light: 'Light',
    system: 'System',
    dark: 'Dark',
    titleOption: '{name} theme',
    current: 'Theme: {name}. Switch theme',
    currentTitle: 'Theme: {name} (click to switch)',
  },
  nav: {
    skip: 'Skip to content',
    open: 'Open navigation',
    close: 'Close navigation',
    main: 'Main navigation',
    home: 'Displaro home',
    organization: 'Organization',
    selectOrganization: 'Select organization',
    sectionMain: 'Main',
    sectionCreate: 'Create',
    sectionScreens: 'Screens',
    sectionInsights: 'Insights',
    sectionAccount: 'Account',
    content: 'Library',
    players: 'Players',
    playerGroups: 'Groups',
    apps: 'Apps',
    dataFeeds: 'Data Feeds',
    analytics: 'Analytics',
    regions: 'Regions',
    tags: 'Tags',
    monitoring: 'Monitoring',
    healthCheck: 'Health Check',
    alerts: 'Alerts',
    activityLog: 'Activity Log',
    reports: 'Reports',
    customAttributes: 'Custom Attributes',
    openIssues: '{n} open issue | {n} open issues',
    accountSettings: 'Account Settings',
    noOrganization: 'No organization',
    expand: 'Expand sidebar',
    collapse: 'Collapse sidebar',
    collapseShort: 'Collapse',
    trialEnded: 'Your free trial has ended.',
    onTrial: 'You’re on the 14-day free trial.',
    seePlans: 'See plans',
  },
  roles: { OWNER: 'Owner', ADMIN: 'Admin', EDITOR: 'Editor', VIEWER: 'Viewer' },
  auth: {
    signInTitle: 'Sign in',
    signInSubtitle: 'Manage your screens and team',
    signingIn: 'Signing in…',
    couldNotSignIn: 'Could not sign in',
    newHere: 'New to Displaro?',
    startTrial: 'Start a 14-day free trial',
    trialTitle: 'Start your free trial',
    trialSubtitle: '{days} days · up to {seats} screens · no card required',
    company: 'Company',
    passwordHint: 'At least 12 characters. A short phrase works well.',
    creating: 'Creating…',
    createAccount: 'Create account',
    couldNotCreate: 'Could not create your account',
    haveAccount: 'Already have an account?',
    inviteTitle: 'Invitation',
    joinOrg: 'Join {org}',
    checkingInvite: 'Checking invitation…',
    inviteInvalid: 'This invitation is invalid or has expired',
    invitedLine: '{inviter} invited {email} to join as {role}',
    joining: 'Joining…',
    accept: 'Accept invitation',
    signedInAsOther: 'You’re signed in as {current}. Sign out and sign in as {email} to accept.',
    signInToAccept: 'Sign in as {email} to accept',
    choosePassword: 'Choose a password',
    createAndJoin: 'Create account & join',
    invalidPassword: 'Invalid password',
    couldNotAccept: 'Could not accept the invitation',
    forgot: 'Forgot password?',
    forgotTitle: 'Reset your password',
    forgotSubtitle: 'We’ll email you a link to choose a new one',
    sendLink: 'Send reset link',
    sending: 'Sending…',
    linkSent: 'If {email} has a Displaro account, a reset link is on its way. It works once, for an hour. Check your spam folder too.',
    backToSignIn: 'Back to sign in',
    resetTitle: 'Choose a new password',
    resetFor: 'For {email}',
    newPassword: 'New password',
    confirmPassword: 'Repeat the new password',
    passwordsDiffer: 'The two passwords are different',
    savePassword: 'Save new password',
    saving: 'Saving…',
    resetInvalid: 'This reset link is invalid, already used or expired.',
    askNewLink: 'Ask for a new link',
    resetDone: 'Your password was changed and every device was signed out. Sign in with the new password.',
  },
  account: {
    title: 'Account Settings',
    uploading: 'Uploading…',
    changePicture: 'Change picture',
    uploadPicture: 'Upload picture',
    pictureHint: 'JPEG, PNG, WebP or GIF, up to 5 MB. It’s cropped to a square. Shown in the sidebar, Members and the Activity Log.',
    pictureFile: 'Profile picture file',
    pictureTooBig: 'The picture must be 5 MB or smaller.',
    pictureUpdated: 'Profile picture updated',
    pictureRemoved: 'Profile picture removed',
    fullName: 'Full name',
    email: 'Email address',
    emailHint: 'Your sign-in email can’t be changed here.',
    timeZone: 'Time zone',
    timeZoneAuto: 'Automatic (this browser: {zone})',
    timeZoneHint: 'Dates and times in the CMS are shown in this zone · now: {now}. Player schedules and restrictions keep each player’s own time zone.',
    language: 'Language',
    languageHint: 'The CMS in your language. Only for you; others keep theirs.',
    numerals: 'Digits in Arabic',
    numeralsArab: 'Arabic-Indic (٠١٢٣)',
    numeralsLatn: 'Western (0123)',
    saved: 'Account settings saved',
    notifications: 'Email notifications',
    weekly: 'Weekly Health Check summary for {org}',
    weeklyHint: 'Mondays at 08:00 in your time zone: open issues, offline players and alerts of the week.',
    weeklyOn: 'You’ll get the Health Check summary every Monday',
    weeklyOff: 'Weekly email turned off',
  },
  ui: ui.en,
  content: content.en,
  appsCat: appsCat.en,
  players: players.en,
  pair: pair.en,
  publish: publish.en,
  placements: placements.en,
  screen: screen.en,
  live: live.en,
  toast: toast.en,
  notify: notify.en,
  sync: sync.en,
  fonts: fonts.en,
  comp: comp.en,
  buildings: buildings.en,
  played: played.en,
  pcp: pcp.en,
  campaign: campaign.en,
  playlist: playlist.en,
  org: org.en,
  reports: reports.en,
  health: health.en,
  alerts: alerts.en,
  analytics: analytics.en,
  groups: groups.en,
  feeds: feeds.en,
  regions: regions.en,
  tagm: tagm.en,
  billing: billing.en,
  plan: plan.en,
  attrs: attrs.en,
  capps: capps.en,
  act: act.en,
  log: log.en,
  layout: layout.en,
  psettings: psettings.en,
  admin: admin.en,
  tfa: tfa.en,
  audioLane: audioLane.en,
  pbHealth: pbHealth.en,
  plays: plays.en,
  rx: rx.en,
  ix: ix.en,
  kiosk: kiosk.en,
  misc: misc.en,
  /** API error codes → text (the server's English is the fallback). */
  errors: {
    QUOTA_SCREENS_EXCEEDED: 'You’ve used all the screens in your plan. Add seats to pair more.',
    TRIAL_EXPIRED: 'Your free trial has ended. Choose a plan to continue.',
    NO_ACTIVE_ORGANIZATION: 'Choose an organization first.',
    INSUFFICIENT_ROLE: 'Your role doesn’t allow this.',
    LAST_OWNER: 'An organization needs at least one owner.',
    RATE_LIMITED: 'Too many attempts. Wait a moment and try again.',
    PAIRING_CODE_INVALID: 'That pairing code isn’t valid or has expired.',
    ASSET_IN_USE: 'This item is in use.',
    LAYOUT_IN_USE: 'This campaign is in use.',
    PLAYLIST_IN_USE: 'This playlist is in use.',
    QUOTA_STORAGE_EXCEEDED: 'Your storage is full. Delete files or upgrade your plan.',
    ASSET_NOT_READY: 'This file is still being optimized.',
    UNSUPPORTED_MEDIA_TYPE: 'This file type isn’t supported.',
    UPLOAD_TOO_LARGE: 'This file is too large.',
  } as Record<string, string>,
};
export default en;
export type Messages = typeof en;
